<div (click)="startTest(parcticeCardData)" class="SLV2-practice-card-box {{selfLearnService?.getSubjectName()?.replace(' ','') | lowercase}}">
    <div class="SLV2-prctcs-tp-prt">
        <div class="SLV2-crd-title-row">
            <span class="SLV2-list-numbr-wrap"></span>
            <img *ngIf="parcticeCardData?.levelsInProgress <= 4 && parcticeCardData?.levelsCompleted < 4" src="selflearnv2-ui/assets/img/self-learn-v2/level-{{parcticeCardData?.levelsInProgress}}-emoji.svg" class="SLV2-crd-lavel-icon" />
            <img *ngIf="parcticeCardData?.levelsCompleted == 4" src="selflearnv2-ui/assets/img/self-learn-v2/level-complete-emoji.svg" class="SLV2-crd-lavel-icon" />
            <h4 class="SLV2-crd-title">{{parcticeCardData?.topicName}}</h4>
        </div>
        
        <div class="SLV2-level-row">
            <ul class="SLV2-level-icon-list" *ngIf="parcticeCardData?.levelsInProgress <= 4 && parcticeCardData?.levelsCompleted < 4" >
                <li [ngClass]="{'current':parcticeCardData?.levelsInProgress == 4}">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/level-batch-icon.png" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/level-active-batch-icon.png" class="color" />
                </li>
                <li [ngClass]="{'current':parcticeCardData?.levelsInProgress == 3}">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/level-batch-icon.png" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/level-active-batch-icon.png" class="color" />
                </li>
                <li [ngClass]="{'current':parcticeCardData?.levelsInProgress == 2}">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/level-batch-icon.png" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/level-active-batch-icon.png" class="color" />
                </li>
                <li [ngClass]="{'current':parcticeCardData?.levelsInProgress == 1}">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/level-batch-icon.png" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/level-active-batch-icon.png" class="color" />
                </li>
                
            </ul>
            <span *ngIf="parcticeCardData?.levelsInProgress > 0 && parcticeCardData?.levelsCompleted < 4">Level {{parcticeCardData?.levelsInProgress}}</span>
            <span class="SLV2-level-complete-text" *ngIf="parcticeCardData?.levelsCompleted == 4"><img src="selflearnv2-ui/assets/img/self-learn-v2/green-tick.svg" /> Levels completed</span>
        </div>
    </div>
    <div class="SLV2-prctcs-btm-prt">
        <button class="SLV2-prctcs-btn" *ngIf="parcticeCardData?.levelsCompleted != 4" (click)="startTest(parcticeCardData)">{{getActionDisplayName(parcticeCardData?.levelsInProgress)}} </button>
        <button class="SLV2-prctcs-btn" *ngIf="parcticeCardData?.levelsCompleted == 4">Practice more </button>
    </div>
</div>
